import { jsonp, post, get } from 'utils/request';
import config from '$config';
import activityMeta from 'utils/activityMeta';
const { templateId } = activityMeta;

// 获取实名认证URL planA
export async function fetchCerificationUrl(callback) {
  const result = await jsonp(`${config.PAGE_ENDPOINT}/common/getApplyCertificationLink`, {
    callbackUrl: callback,
  });
  return result.data;
}
// 获取实名认证URL planB
export async function fetchCerificationCode() {
  return await jsonp(`${config.PAGE_ENDPOINT}/common/getApplyCertificationLink2`, {
    certifyMethod: 3,
  });
}
// 获取团信息接口
export async function fetchGroupInfo() {
  return await jsonp(`${config.DASHI_ENDPOINT}/activity/group/property`, {
    templateId,
    isRank: true,
  });
}

// 留言板发送消息接口
export async function sendMsg(parmes) {
  return await jsonp(`${config.DASHI_ENDPOINT}/activity/group/addGroupComment`, {
    ...parmes,
  });
}

// 留言板消息接口
export async function getGroupComments(parmes) {
  return await jsonp(`${config.DASHI_ENDPOINT}/activity/group/getGroupComments`, {
    ...parmes,
  });
}

// 分页获取团成员列表
export async function queryGroupMembers(params) {
  return await jsonp(`${config.DASHI_ENDPOINT}/activity/group/queryGroupMembers`, {
    ...params,
  });
}

// 开团接口
export async function createTeam(params) {
  return await jsonp(`${config.DASHI_ENDPOINT}/activity/group/create`, {
    source: JSON.stringify({
      spma: '5176',
      spmb: $('body').context.body.dataset.spm,
      channel: params.channel,
      shareType: params.shareType,
    }),
    templateId,
    ...params,
  });
}

// 修改团信息接口
export async function changeTeamInfo(params) {
  return await post(`${config.DASHI_ENDPOINT}/activity/group/modify`, {
    templateId,
    ...params,
  });
}

// 团排行榜接口
export async function leagueTable() {
  return await jsonp(`${config.DASHI_ENDPOINT}/api/activity/group/getGroupRankList`, {
    templateId,
  });
}

// 团排行榜接口
export async function fetchFinalLeagueTable() {
  try {
    const result = (await get('https://query.aliyun.com/rest/groupBuying.finalLeagueTable')) || {};
    return result.data;
  } catch (error) {
    console.error(error);
  }
}

// 开团前校验的接口
export async function CreateTeamCheck() {
  return await jsonp(`${config.DASHI_ENDPOINT}/activity/group/createVerify`, {
    templateId,
  });
}

// 判断当前登录用户是否有资格成为云大使
export async function checkAccountForAmbassador() {
  return await jsonp(
    `${config.PROMOTION_ENDPOINT}/promotion/ambassador/checkAccountForAmbassador.htm`,
    {},
    { jsonpCallback: 'cback' }
  );
}

// 签约云大使
export async function applyAmbassador() {
  return await jsonp(
    `${config.PROMOTION_ENDPOINT}/promotion/ambassador/applyAmbassador.htm`,
    {
      source: JSON.stringify({
        spma: '5176',
        spmb: $('body').context.body.dataset.spm,
      }),
    },
    { jsonpCallback: 'cback' }
  );
}

//获取云大使信息
export async function fetchAmbassadorInfo() {
  return await jsonp(
    `${config.PROMOTION_ENDPOINT}/promotion/ambassador/getAmbassadorBasicInfo.htm`,
    {},
    { jsonpCallback: 'cback' }
  );
}

// 判断新老用户的接口
export async function judgeNewUsers(activityCode) {
  return await jsonp('https://page.aliyun.com/validate/verify', {
    activityCode,
  });
}
// 解散团
export async function disbandingGroup(groupCode) {
  return await post(`${config.DASHI_ENDPOINT}/activity/group/dissolve`, {
    groupCode,
  });
}

// 判断实名认证接口
export async function checkCertification() {
  const result = await jsonp('https://page.aliyun.com/validate/verify', {
    activityCode: 'services_real',
  });
  if (result.code == 'VALIDATE_SUCCESS') {
    return true;
  } else {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/services/DashboardService.js